import { render } from "./GradientButton.vue?vue&type=template&id=642c771e"
import script from "./GradientButton.vue?vue&type=script&lang=js"
export * from "./GradientButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__